import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import ReplayIcon from "@mui/icons-material/Replay";

import { Rating } from "../../Shared/Ratings/Rating";
import { Common, ERROR, Ratings, SUCCESS } from "../../../helper";
import { errorMsg, LoadingSpinner, success } from "../../Shared";
import * as reportApi from "../../../api/reportApi";
import * as commonApi from "../../../api/commonApi";
import { isEmptyArray, isEmptyObject } from "../../../util";
import { CustomConfirmModal, ProgressGraph } from "./";

import "../../../assets/stlyes/ProgressReports/progressReport.scss";
import "../../../assets/stlyes/Modals.css";

import schoolProfileImage from "../../../assets/images/schoolProfile.png";
import TargetIcon from "../../../assets/icons/TargetIcon.png";
import SaveIcon from "../../../assets/images/Save.png";
import DeleteIcon from "../../../assets/images/deleteMinus.svg";

const PupilReport = (props) => {
  const { setInd, setEventKey } = props;
  const savedReports = sessionStorage.getItem("savedReports")
  const [isViewOrEdit, setIsViewOrEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [addGeneralCommentButton, setAddGeneralCommentButton] = useState(false)
  const [showRatingModal, setShowRatingModal] = useState(false)
  const pupilData = useSelector((state) => state.pupilProgress.pupilInfo);
  // const [pupilResult, setPupilResult] = useState();
  const [activeModalIcon, setActiveModalIcon] = useState();
  const [activeModalColor, setActiveModalColor] = useState();
  const [ks1Results, setKs1Results] = useState([]);
  const [subSelectedIndex, setSelectedSubIndes] = useState([]);
  const [applyToAllSubject, setApplyToAllSubject] = useState(false);
  const [additionalSubjectIconEdit, setAdditionalSubjectIconEdit] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedSubjectConfirmIndex, setSelectedSubjectConfirmIndex] = useState(null);
  const [whichTodelete, setWhichTodelete] = useState({
    additionalSubject: false,
    reset: false,
    generalComment: false,
    mainSubject: false
  });
  const [PupilProgressReport, setPupilProgressReport] = useState();
  let constantVariableObject = {
    pupilId: pupilData?.id,
    schoolId: "",
    firstName: pupilData?.firstName,
    lastName: pupilData?.lastName,
    schoolName: "",
    year: pupilData?.year,
    subjects: [
      {
        subjectName: "Maths",
        Graph: {
          ks1Result: "",
          previousYearResult: ""
        },
        yearEndPrediction: {
          predictedOutcome: "", objectivesPassed: 0
        },
        currentOutcome: {
          objectivesPassed: 0, objectivesMarked: 0
        },
        subjectStrength: [],
        Targets: [
          {
            name: "",
            target: "",
            marking: ""
          }
        ],
        rating: {
          icon: "Apple",
          value: 0,
          color: "Purple",
        },
        ratio: [],
        pieChart: [],
        comment: ""
      },
      {
        subjectName: "Reading",
        Graph: {
          ks1Result: "",
          previousYearResult: ""
        },
        yearEndPrediction: {
          predictedOutcome: "", objectivesPassed: 0
        },
        currentOutcome: {
          objectivesPassed: 0, objectivesMarked: 0
        },
        subjectStrength: [],
        Targets: [
          {
            name: "",
            target: "",
            marking: ""
          }
        ],
        rating: {
          icon: "Apple",
          value: 0,
          color: "Purple",
        },
        ratio: [],
        pieChart: [],
        comment: ""
      },
      {
        subjectName: "Writing",
        Graph: {
          ks1Result: "",
          previousYearResult: ""
        },
        yearEndPrediction: {
          predictedOutcome: "", objectivesPassed: 0
        },
        currentOutcome: {
          objectivesPassed: 0, objectivesMarked: 0
        },
        subjectStrength: [],
        Targets: [
          {
            name: "",
            target: "",
            marking: ""
          }
        ],
        rating: {
          icon: "Apple",
          value: 0,
          color: "Purple",
        },
        ratio: [],
        pieChart: [],
        comment: ""
      },
      {
        subjectName: "Science",
        Graph: {
          ks1Result: "",
          previousYearResult: ""
        },
        yearEndPrediction: {
          predictedOutcome: "", objectivesPassed: 0
        },
        currentOutcome: {
          objectivesPassed: 0, objectivesMarked: 0
        },
        subjectStrength: [],
        Targets: [
          {
            name: "",
            target: "",
            marking: ""
          }
        ],
        rating: {
          icon: "Apple",
          value: 0,
          color: "Purple",
        },
        ratio: [],
        pieChart: [],
        comment: ""
      },
      {
        subjectName: "PE",
        Graph: {
          ks1Result: "",
          previousYearResult: ""
        },
        yearEndPrediction: {
          predictedOutcome: "", objectivesPassed: 0
        },
        currentOutcome: {
          objectivesPassed: 0, objectivesMarked: 0
        },
        subjectStrength: [],
        Targets: [
          {
            name: "",
            target: "",
            marking: ""
          }
        ],
        rating: {
          icon: "Apple",
          value: 0,
          color: "Purple",
        },
        ratio: [],
        pieChart: [],
        comment: ""
      },
    ],
    additionalSubject: [],
    generalComments: [{
      comment: ""
    }]
  }

  const additionalSubjectBlock = {
    subjectName: "",
    rating: {
      icon: applyToAllSubject ? activeModalIcon : "Apple", color: applyToAllSubject ? activeModalColor : "Purple", value: 0
    },
    comment: ""
  }

  const getPupilSchool = async (constantVariableObject) => {
    const schoolDetails = await commonApi.getCurrentSchool();
    let progress = constantVariableObject;
    progress.schoolId = schoolDetails.Items.id;
    progress.schoolName = schoolDetails.Items.name;
    setPupilProgressReport({ ...PupilProgressReport, ...progress });
  }

  const getResults = async (constantVariableObject) => {
    const getResult = await commonApi.getMarksByPupilIdAccordians({ pupilId: pupilData.id, year: parseInt(pupilData.year) });
    if (!isEmptyObject(getResult.Items)) {
      // setPupilResult(getResult.Items);
      const ks1Array = getResult.Items.map(item => item.keyStage1Result);
      setKs1Results(ks1Array);
      console.log({ ks1Results, ks1Array });
      let progress = constantVariableObject;
      progress.subjects.map((sub, i) => {
        // sub.Targets = getResult?.Items[i]?.target;
        console.log({ sub: sub.Graph.ks1Result });
        sub.Graph.ks1Result = getResult?.Items[i]?.keyStage1Result ? getResult?.Items[i]?.keyStage1Result : "";
        sub.Graph.previousYearResult = getResult?.Items[i]?.previousYearResult ? getResult?.Items[i]?.previousYearResult : "";
        sub.yearEndPrediction.predictedOutcome = getResult?.Items[i]?.yearEndPrediction ? getResult?.Items[i]?.yearEndPrediction : "";
        sub.subjectStrength = getResult?.Items[i]?.category ? getResult?.Items[i]?.category : [];
        sub.Targets = getResult?.Items[i]?.target ? getResult?.Items[i]?.target : []
        sub.ratio = getResult?.Items[i]?.ratio ? getResult?.Items[i]?.ratio : []
        sub.pieChart = getResult?.Items[i]?.pieChart ? getResult?.Items[i]?.pieChart : []

        sub.comment = getResult.Items[i].comment;
      })

      setPupilProgressReport({ ...PupilProgressReport, ...progress });

    }
  }

  const getKeyStageGraphValue = (ksResult) => {
    switch (ksResult) {
    case "KS1B": return ((0.25 * 100) - 12.5);
    case "KS1L": return ((0.5 * 100) - 12.5);
    case "KS1M": return ((0.75 * 100) - 12.5);
    case "KS1H": return ((1 * 100) - 12.5);
    default: return 12.5
    }
  }

  const getYearEndGraphValue = (subject, pupilYear) => {
    if (subject?.yearEndPrediction?.predictedOutcome !== "") {
      if (subject?.yearEndPrediction?.predictedOutcome.includes(pupilYear)) {
        if (subject?.yearEndPrediction?.predictedOutcome?.includes("B")) {
          return 12.5;
        } else if (subject?.yearEndPrediction?.predictedOutcome?.includes("W")) {
          return 37.5
        } else if (subject?.yearEndPrediction?.predictedOutcome?.includes("E")) {
          return 62.5
        } else if (subject?.yearEndPrediction?.predictedOutcome?.includes("G")) {
          return 87.5
        }
      } else {
        return 12.5
      }
    } else {
      return 5
    }
  }

  const getPredictedText = (subject, pupilYear) => {
    if (subject?.yearEndPrediction.predictedOutcome !== "") {
      if (subject?.yearEndPrediction?.predictedOutcome.includes(pupilYear)) {
        if (subject?.yearEndPrediction?.predictedOutcome.includes("B")) {
          return "Below";
        } else if (subject?.yearEndPrediction?.predictedOutcome.includes("W")) {
          return "Emerging"
        } else if (subject?.yearEndPrediction?.predictedOutcome.includes("E")) {
          return "Expected"
        } else if (subject?.yearEndPrediction?.predictedOutcome.includes("G")) {
          return "Greater Depth"
        }
      } else {
        return "Below"
      }
    } else {
      return "Below"
    }
  }

  // const getRatioOfPass = (req, index) => {
  //   if (req[index].pieChart.length > 0) {
  //     let passedValues = req[index].pieChart.map(item => {
  //       if (item.name === "3E" || item.name === "3G") {
  //         return item.value;
  //       } else {
  //         return 0;
  //       }
  //     });
  //     let numberOfObjectivesPassed = passedValues.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  //     let totalMarked = req[index].ratio[0].totalMarking;
  //     let passRatio = (numberOfObjectivesPassed * 100 / totalMarked);
  //     let progressRep = PupilProgressReport;
  //     progressRep.subjects[index].yearEndPrediction.objectivesMarked = passRatio;
  //     return progressRep?.subjects[index]?.yearEndPrediction?.objectivesMarked;
  //   } else return 0;
  // }
  const getRatioOfPass = (sub) => {
    if (sub.ratio && sub.pieChart) {
      if (!isEmptyArray(sub.ratio) && !isEmptyArray(sub.pieChart)) {
        let totalG = sub.pieChart.filter(item => item.name.includes("G")).reduce((sum, item) => sum + item.value, 0);
        let totalE = sub.pieChart.filter(item => item.name.includes("E")).reduce((sum, item) => sum + item.value, 0);
        return (((totalG + totalE) / sub?.ratio[0]?.totalMarking) * 100).toFixed(2)
      }
      return 0
    } else {
      return 0
    }
  }

  const getCurrentSecureRatio = (sub) => {
    if (sub.ratio && sub.pieChart) {
      if (!isEmptyArray(sub.ratio) && !isEmptyArray(sub.pieChart)) {
        let totalG = sub.pieChart.filter(item => item.name.includes("G")).reduce((sum, item) => sum + item.value, 0);
        let totalE = sub.pieChart.filter(item => item.name.includes("E")).reduce((sum, item) => sum + item.value, 0);
        return (((totalG + totalE) / sub?.ratio[0]?.totalDescription) * 100).toFixed(2)
      }
      return 0
    } else {
      return 0
    }
  };
  const getTotalSkillsMarked = (sub) => {
    if (sub.ratio) {
      if (!isEmptyArray(sub.ratio)) {
        return sub?.ratio[0]?.totalMarking
      }
      return 0
    } else {
      return 0
    }
  };

  const setRatingIcon = (icon) => {
    switch (icon) {
    case "Apple": return Ratings.Icons.Apple;
    case "Bear": return Ratings.Icons.Bear;
    case "Bolt": return Ratings.Icons.Bolt;
    case "Dog": return Ratings.Icons.Dog;
    case "Horse": return Ratings.Icons.Horse;
    case "Icecream": return Ratings.Icons.Icecream;
    case "Lantern": return Ratings.Icons.Lantern;
    case "Lizard": return Ratings.Icons.Lizard;
    case "Star": return Ratings.Icons.Star;
    case "Watermelon": return Ratings.Icons.Watermelon;
    default: return Ratings.Icons.Apple;
    }
  }
  const setRatingColor = (color) => {
    document.documentElement.style.setProperty("--selected-color", Ratings.Colours[color]);
    switch (color) {
    case "Blue": return Ratings.Colours.Blue;
    case "Green": return Ratings.Colours.Green;
    case "Orange": return Ratings.Colours.Orange;
    case "Purple": return Ratings.Colours.Purple;
    case "Yellow": return Ratings.Colours.Yellow;
    default: return Ratings.Colours.Purple;
    }
  }

  const onSaveReport = async () => {
    setIsLoading(true);
    let report = PupilProgressReport;
    const hasEmptySubjectName = report.additionalSubject.some(subject => subject.subjectName.trim() === "");

    if (hasEmptySubjectName) {
      setIsLoading(false);
      errorMsg(ERROR.SUBJECT_NAME_REQUIRED_FOR_ADDITIONAL_SUBJECT);
      return;
    }
    
    const reports = await reportApi.saveReport(report);
    if (!isEmptyObject(reports)) {
      setIsViewOrEdit(false);
      setIsLoading(false);
      setInd(2);
      success(SUCCESS.REPORT_SAVED)
      sessionStorage.removeItem("savedReports")
    } else {
      setIsLoading(false);
      errorMsg(ERROR.REPORT_NOT_SAVED)
    }
  }

  // Function to check if all items have the same icon and color
  const hasConsistentRating = (items) => {
    if (items.length === 0) return false;

    const { icon, color } = items[0].rating;

    return items.every(item => item.rating.icon === icon && item.rating.color === color);
  };

  const handleRatingModalOpen = (icon) => {
    setShowRatingModal(true);
    setActiveModalIcon(icon);
  };

  const handleColorClick = (color) => {
    setActiveModalColor(color);
    document.documentElement.style.setProperty("--selected-color", Ratings.Colours[color]);
  };

  const updateModalDetails = () => {
    let updatedSubjects = {}
    let updatedAdditionalSubjects = {}
    if (applyToAllSubject) {
      updatedAdditionalSubjects = PupilProgressReport.additionalSubject.map((subject_) => {
        return {
          ...subject_,
          rating: {
            icon: activeModalIcon,
            value: subject_.rating.value,
            color: activeModalColor
          }
        };
      })
      updatedSubjects = PupilProgressReport.subjects.map((subject_) => {
        return {
          ...subject_,
          rating: {
            icon: activeModalIcon,
            value: subject_.rating.value,
            color: activeModalColor
          }
        };
      })
    }
    if (additionalSubjectIconEdit && !applyToAllSubject) {
      updatedAdditionalSubjects = PupilProgressReport.additionalSubject.map((subject_, ind) => {
        if (ind === subSelectedIndex.additionalindex) {
          return {
            ...subject_,
            rating: {
              icon: activeModalIcon,
              value: subject_.rating.value,
              color: activeModalColor
            }
          };
        }
        return subject_;
      });
    } else if (!applyToAllSubject) {
      updatedSubjects = PupilProgressReport.subjects.map((subject_) => {
        if (subject_.subjectName === subSelectedIndex.subject.subjectName) {
          return {
            ...subject_,
            rating: {
              icon: activeModalIcon,
              value: subject_.rating.value,
              color: activeModalColor
            }
          };
        }
        return subject_;
      });
    }

    if (applyToAllSubject) {
      setPupilProgressReport({
        ...PupilProgressReport,
        additionalSubject: updatedAdditionalSubjects,
        subjects: updatedSubjects
      });
    } else if (additionalSubjectIconEdit) {
      setPupilProgressReport({
        ...PupilProgressReport,
        additionalSubject: updatedAdditionalSubjects
      });
    } else {
      setPupilProgressReport({
        ...PupilProgressReport,
        subjects: updatedSubjects
      });
    }
    setShowRatingModal(false);
  }

  const handleClick = (subIndex) => {
    setInd(1);
    setEventKey(subIndex);
  }

  const updateComment = (event, subIndex, isGeneralComment, isAdditionalSubject) => {
    if (isGeneralComment) {
      PupilProgressReport.generalComments[subIndex].comment = event.target.value
    } else if (isAdditionalSubject) {
      PupilProgressReport.additionalSubject[subIndex].comment = event.target.value
    } else {
      PupilProgressReport.subjects[subIndex].comment = event.target.value
    }
  }

  const addAdditionalSubjects = () => {
    if (PupilProgressReport.additionalSubject.length >= 4) {
      errorMsg(ERROR.MAXIMUM_4_SUBJECT);
      return;
    }
    let progress = { ...PupilProgressReport };
    progress.additionalSubject.push({ ...additionalSubjectBlock });
    setPupilProgressReport(progress);
  }

  const addGeneralComments = () => {
    // let progress = PupilProgressReport;
    setAddGeneralCommentButton(true)
    // progress.generalComments.push(generalComment);
    // setPupilProgressReport(progress);
  }

  const deleteGeneralComments = () => {
    setWhichTodelete({
      additionalSubject: false,
      reset: false,
      generalComment: true,
      mainSubject: false
    })
    setIsConfirmModalOpen(true);
  }

  const confirmDeleteGeneralComments = () => {
    PupilProgressReport.generalComments[0].comment = ""
    setAddGeneralCommentButton(false);
    setIsConfirmModalOpen(false);
  }

  const confirmResetReport = () => {
    setIsConfirmModalOpen(false);
    window.location.reload();
  }

  const handleAdditionalSubjectNameChange = (event, index) => {
    let updatedSubjects = [...PupilProgressReport.additionalSubject];
    updatedSubjects[index].subjectName = event.target.value;
    setPupilProgressReport((prevReport) => ({
      ...prevReport,
      additionalSubject: updatedSubjects
    }));
  };

  const handleConfirmDeleteMainSubject = (index) => {
    let updatedSubjects = [...PupilProgressReport.subjects];
    updatedSubjects.splice(index, 1);
    setPupilProgressReport((prevReport) => ({
      ...prevReport,
      subjects: updatedSubjects
    }));
    setIsConfirmModalOpen(false);
  };

  const handleConfirmDeleteAdditionalSubject = (index) => {
    let updatedSubjects = [...PupilProgressReport.additionalSubject];
    updatedSubjects.splice(index, 1);
    setPupilProgressReport((prevReport) => ({
      ...prevReport,
      additionalSubject: updatedSubjects
    }));
    setIsConfirmModalOpen(false);
  };

  const handleDeleteAdditionalSubject = (index) => {
    setWhichTodelete({
      additionalSubject: true,
      reset: false,
      generalComment: false,
      mainSubject: false
    })
    setSelectedSubjectConfirmIndex(index);
    setIsConfirmModalOpen(true);
  };
  const handleDeleteMainSubject = (index) => {
    setWhichTodelete({
      additionalSubject: false,
      reset: false,
      generalComment: false,
      mainSubject: true
    })
    setSelectedSubjectConfirmIndex(index);
    setIsConfirmModalOpen(true);
  };

  const handleConfirmWhichToDelete = () => {
    whichTodelete.additionalSubject ? handleConfirmDeleteAdditionalSubject(selectedSubjectConfirmIndex) : whichTodelete.reset ? confirmResetReport() : whichTodelete.generalComment ? confirmDeleteGeneralComments() : whichTodelete.mainSubject ? handleConfirmDeleteMainSubject(selectedSubjectConfirmIndex) : "";
    setWhichTodelete({
      additionalSubject: false,
      reset: false,
      generalComment: false,
      mainSubject: false
    })
  };

  const handleCloseConfirmModal = () => {
    setIsConfirmModalOpen(false);
    setSelectedSubjectConfirmIndex(null);
  };

  const resetReport = () => {
    setWhichTodelete({
      additionalSubject: false,
      reset: true,
      generalComment: false,
      mainSubject: false
    })
    setIsConfirmModalOpen(true);
  }

  const loadDynamicReport = () => {
    sessionStorage.removeItem("savedReports")
    window.location.reload();
  }

  const getPupilReports = async () => {
    if (savedReports) {
      let savedReport = JSON.parse(savedReports)
      
      setPupilProgressReport(savedReport);

      // To check apply to ApplyToAllSubject checkbox based on icon and icon color
      // Extract ratings, icons and icon color from subjects and additional subjects
      const subjects = savedReport.subjects || [];
      const additionalSubjects = savedReport.additionalSubject || [];

      // Check if all subjects and additional subjects have the same rating
      const subjectsConsistent = hasConsistentRating(subjects);
      const additionalSubjectsConsistent = hasConsistentRating(additionalSubjects);
      (subjectsConsistent && additionalSubjectsConsistent) ? setApplyToAllSubject(true) : setApplyToAllSubject(false);

      savedReport?.generalComments[0]?.comment && setAddGeneralCommentButton(true)
    } else {
      setPupilProgressReport(constantVariableObject)
      setIsLoading(true)
      getPupilSchool(constantVariableObject);
      getResults(constantVariableObject);
      setIsLoading(false)
    }
  }
  const showCurrentTimeZoneFormat = (timeStamp) => {
    const ukDateTimeString = timeStamp;
    const ukDate = new Date(`${ukDateTimeString} GMT+0100`);
    const localDateTimeString = ukDate.toLocaleString();
    return localDateTimeString
  }

  useEffect(() => {
    getPupilReports();
  }, [])

  return (
    <div className="PupilReport graphTabPanel">
      {isLoading && <LoadingSpinner />}
      <div className="editBlock" style={{ flexDirection: savedReports ? "" : "row-reverse" }}>
        {JSON.parse(savedReports) && <p className="generatedClass">{JSON.parse(savedReports)?.reportName} Generated on {JSON.parse(savedReports)?.updatedAt ? showCurrentTimeZoneFormat(JSON.parse(savedReports)?.updatedAt) : ""}</p>}
        {JSON.parse(savedReports) && <button onClick={() => loadDynamicReport()} className="editReportButton" >{Common.ViewCurrentProgress}</button>}
        {!isViewOrEdit && <button onClick={() => setIsViewOrEdit(true)} className="editReportButton" >{Common.EditReport}</button>}
      </div>
      <div className="studentSchoolBlock">
        <div className="studentDetails">
          <span className="studentName">{`${PupilProgressReport?.lastName} ${PupilProgressReport?.firstName} `}</span>
          <span className="schoolName">{`${PupilProgressReport?.schoolName}`}</span>
          <span className="reportAndYear">{`Year ${PupilProgressReport?.year} Report`}</span>
        </div>
        <div className="schoolImage">
          <img className="schoolLogo" src={schoolProfileImage} alt="" />
        </div>

      </div>
      {!isLoading && PupilProgressReport && PupilProgressReport.subjects?.map((subject, subIndex) => (
        <div className="progressSubjectBlock" key={subIndex} >
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column">
              <span className="subjectTitle">{subject.subjectName}</span>
              <span className="subjectSubtitle">{Common.ProgressMeter}</span>
            </div>
            {isViewOrEdit && <div className="d-flex justify-content-end"><button onClick={() => handleDeleteMainSubject(subIndex)} style={{ background: "none" }}><img src={DeleteIcon} alt="" /></button></div>}
          </div>
          <div className="graphBlock">
            <ProgressGraph ks1Value={getKeyStageGraphValue(subject?.Graph.ks1Result)} currentValue={getYearEndGraphValue(subject, PupilProgressReport?.year)} />
            <div className="graphlabels">
              <span className="labelText">
                Pointer: Prediction
              </span>
              <span className="labelText">
                Dotted line: Target
              </span>
              <span className="labelText">
                <div className="buttonStyleProgress" style={{ background: "var(--greater-colour)" }} />{Common.GreaterDepth}
              </span>
              <span className="labelText">
                <div className="buttonStyleProgress" style={{ background: "var(--expected-colour)" }} />{Common.Expected}
              </span>
              <span className="labelText">
                <div className="buttonStyleProgress" style={{ background: "var(--emerging-colour)" }} />{Common.WorkingTowards}
              </span>
              <span className="labelText">
                <div className="buttonStyleProgress" style={{ background: "var(--below-colour)" }} />{Common.WorkingBelow}
              </span>
            </div>
          </div>
          <div className="yearEndPredictionBlock">
            <span className="blockTitle" >{Common.YearEndPrediction}</span>
            <div className="valueBlocks">
              <span className="yearEndValue">{`Year ${pupilData.year} ${getPredictedText(subject, pupilData.year)} Standard`}</span>
              <span className="yearEndValue">{`${getRatioOfPass(subject)}% of ${subject.subjectName} skills secure`}</span>
            </div>
          </div>
          <div className="currentOutcomeBlock">
            <span className="blockTitle" >{Common.CurrentOutcome}</span>
            <div className="valueBlocks">
              <span className="yearEndValue">{`${getCurrentSecureRatio(subject)}% of ${subject.subjectName} skills secure`}</span>
              <span className="yearEndValue">{`${getTotalSkillsMarked(subject)} skills assessed so far this year`}</span>
            </div>
          </div>
          <div className="subjectAreaStrengthsBlock">
            <span className="blockTitle" >{Common.SubjectAreaStrengths}</span>
            <div className="valueBlocks">
              {subject.subjectStrength.map((category, i) => (
                <span className="yearEndValue" key={i}>{category.name}</span>
              ))}

            </div>
          </div>
          <div className="TargetsBlock">
            <div style={{ margin: "10px 0px" }}>
              <span className="blockTitle" >{Common.Targets}</span>{isViewOrEdit && <button className="editBlockTitle" onClick={() => handleClick(subIndex)} >{Common.ChangeTargets}</button>}
            </div>
            {subject.Targets.map((t, i) => (
              <div key={i} className="target">
                <img src={TargetIcon} alt="" />
                <span>{`${t.name} : ${t.target}`}</span>
              </div>
            ))}
          </div>
          <div className="RatingsBlock">
            <div style={{ margin: "10px 0px" }}>
              <span className="blockTitle" >{Common.AttitudeToLearning}</span>
              {isViewOrEdit && <button className="editBlockTitle" onClick={() => { setShowRatingModal(true); setActiveModalIcon(subject?.rating?.icon); setActiveModalColor(subject?.rating.color); setSelectedSubIndes({ subIndex, subject }); setAdditionalSubjectIconEdit(false) }}>{Common.EditIcon}</button>}
            </div>
            <Rating icon={setRatingIcon(subject.rating.icon)} colour={setRatingColor(subject.rating.color)} initialRating={subject.rating.value} isViewOrEdit={isViewOrEdit} PupilProgressReport={PupilProgressReport} subjectIndex={subIndex} isAdditionalSubject={false} />
          </div>
          <div className="CommentBlock">
            <span className="blockTitle" >{Common.TeacherComment}</span>
            <div className="teacher-comment-box">
              <div className="teacher-comment-box-edit-comment">
                <MessageOutlinedIcon />
                {Common.EditComment}
              </div>
              <textarea id="progress-comment" name="progress-comment" disabled={!isViewOrEdit} onChange={(event) => updateComment(event, subIndex, false, false)} className="progress-comment" rows="4" cols="65" defaultValue={subject?.comment}></textarea>
            </div>
          </div>
        </div>
      ))
      }
      {!isLoading && PupilProgressReport && PupilProgressReport.additionalSubject?.map((additionSub, additionalindex) => (
        <div key={additionalindex} className="additional-subject progressSubjectBlock">
          <div className="d-flex justify-content-between">
            <input type="text" className="subjectTitle" style={{ border: "None", background: "None" }} placeholder="Subject Name" value={additionSub.subjectName} onChange={(e) => handleAdditionalSubjectNameChange(e, additionalindex)} disabled={!isViewOrEdit} />
            {isViewOrEdit && <div className="d-flex justify-content-end"><button onClick={() => handleDeleteAdditionalSubject(additionalindex)} style={{ background: "none" }}><img src={DeleteIcon} alt="" /></button></div>}
          </div>
          <div className="RatingsBlock">
            <div style={{ margin: "10px 0px" }}>
              <span className="blockTitle" >{Common.AttitudeToLearning}</span>
              {isViewOrEdit && <button className="editBlockTitle" onClick={() => { setShowRatingModal(true); setActiveModalIcon(additionSub?.rating?.icon); setActiveModalColor(additionSub?.rating.color); setSelectedSubIndes({ additionalindex, additionSub }); setAdditionalSubjectIconEdit(true) }}>{Common.EditIcon}</button>}
            </div>
            <Rating icon={setRatingIcon(additionSub?.rating?.icon)} colour={setRatingColor(additionSub?.rating?.color)} initialRating={additionSub?.rating?.value} isViewOrEdit={isViewOrEdit} PupilProgressReport={PupilProgressReport} subjectIndex={additionalindex} isAdditionalSubject={true} />
          </div>
          <div className="CommentBlock">
            <span className="blockTitle" >Teacher Comment</span>
            <div className="teacher-comment-box">
              <div className="teacher-comment-box-edit-comment">
                <MessageOutlinedIcon />
                {Common.EditComment}
              </div>
              <textarea id="progress-comment" name="progress-comment" disabled={!isViewOrEdit} onChange={(event) => updateComment(event, additionalindex, false, true)} className="progress-comment" rows="4" cols="65" defaultValue={additionSub?.comment}></textarea>
            </div>
          </div>
        </div>
      ))}
      {
        !isLoading && addGeneralCommentButton && PupilProgressReport && PupilProgressReport?.generalComments?.map((comment, commentIndex) => (
          <div className="general-comment-box" key={commentIndex} >
            <div className="CommentBlock" style={{ width: "100%" }}>
              <div className="d-flex justify-content-between">
                <span className="blockTitleGeneralComment" >General Comment</span>
                {(addGeneralCommentButton && isViewOrEdit) && <div className="d-flex justify-content-end"><button onClick={() => deleteGeneralComments()} style={{ background: "none" }}><img src={DeleteIcon} alt="" /></button></div>}
              </div>
              <div className="teacher-comment-box-general-comment">
                <div className="teacher-comment-box-edit-comment">
                  <MessageOutlinedIcon />
                  {Common.EditComment}
                </div>
                <textarea id="progress-comment" name="progress-comment" disabled={!isViewOrEdit} onChange={(event) => updateComment(event, commentIndex, true, false)} className="progress-comment" rows="4" cols="65" defaultValue={comment?.comment}></textarea>
              </div>

            </div>
          </div>
        ))
      }
      <Modal size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered show={showRatingModal}>
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            <span className="ModelHeader">Attitude to Learning Icons</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="ModalBody">
          <span className="modal-subtitle">Select Icon</span>
          <div className="iconList">
            {Ratings.IconList.map((icon, index) => (
              <svg key={index} width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => handleRatingModalOpen(icon)} >
                <path d={Ratings.Icons[icon]} fill={activeModalIcon === icon ? setRatingColor(activeModalColor) : Ratings.Colours.Grey} />
              </svg>))}
          </div>
          <hr />
          <span className="modal-subtitle">Select Color</span>
          <div className="modal-subtitle-color">
            {Object.keys(Ratings.Colours).slice(0, -1).map((color, index) => (
              <button
                key={index}
                className={`colorCircle ${activeModalColor === color ? "selected" : ""}`}
                style={{ borderColor: Ratings.Colours[color] }}
                onClick={() => handleColorClick(color)}
              />
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="modalSelectIcon">
          <div className="applyAllCheckbox">
            <input
              type="checkbox"
              id="applyAllCheckbox"
              checked={applyToAllSubject}
              onChange={() => setApplyToAllSubject(!applyToAllSubject)}
            />
            <label htmlFor="applyAllCheckbox" className="applyAllCheckboxName">Apply to all subjects</label>
          </div>
          <div>
            <button onClick={() => setShowRatingModal(false)} className="cancel-button">Cancel</button>
            <button className="update-button" onClick={() => { updateModalDetails() }} >
              <img src={SaveIcon} alt="Update" /> Update
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <CustomConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={handleCloseConfirmModal}
        onConfirm={handleConfirmWhichToDelete}
        subjectName={whichTodelete.additionalSubject ? PupilProgressReport && PupilProgressReport?.additionalSubject[selectedSubjectConfirmIndex]?.subjectName : whichTodelete.mainSubject ? PupilProgressReport && PupilProgressReport?.subjects[selectedSubjectConfirmIndex]?.subjectName : ""}
        whichTodelete={whichTodelete && whichTodelete}
      />
      {
        isViewOrEdit && <div className="save-button-block">
          <div>
            {!addGeneralCommentButton && <button onClick={() => addGeneralComments()} className="comment-button">Add Comment Box <MessageOutlinedIcon /></button>}
            <button onClick={() => addAdditionalSubjects()} className="subject-button">Add Subject Box</button>
          </div>
          <div>
            {savedReports && <button onClick={() => resetReport()} className="reset-button"><ReplayIcon />Reset</button>}
            <button onClick={() => { onSaveReport() }} className="save-button"><img src={SaveIcon} alt="" />Save Report</button>
          </div>
        </div>
      }
    </div >
  )
}

export { PupilReport }